export default __webpack_public_path__ + "images/7555df99ee345300f39a9c8ddff5c20a-punk_music.jpg";